// eslint-disable-next-line
export const env = {
	production: false,
  apiUrl: 'https://api-adm-dev.gek-group.com',
  env: 'stage',
}



// WEBPACK FOOTER //
// ./src/constants/env.js